(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initMotion = (root) => {
    if (!root || root.dataset.agMotionInitialized === 'true') return;
    root.dataset.agMotionInitialized = 'true';

    if (reducedMotion.matches) {
      root.classList.add('ag-motion-reduced');
      return;
    }

    root.classList.add('ag-motion-enabled');
    const revealItems = new Set();

    const addReveal = (element, delay = 0, media = false) => {
      if (!element || revealItems.has(element)) return;
      element.classList.add('ag-reveal');
      if (media) element.classList.add('ag-reveal--media');
      element.style.setProperty('--ag-delay', delay + 'ms');
      revealItems.add(element);
    };

    const addGroup = (elements, step = 75, media = false) => {
      Array.from(elements).forEach((element, index) => {
        addReveal(element, (index % 6) * step, media);
      });
    };

    addGroup(root.querySelectorAll('.ag-home__hero-copy > *'), 85);
    addReveal(root.querySelector('.ag-home__hero-media'), 180, true);
    addGroup(root.querySelectorAll('.ag-home__trust article'), 90);

    root.querySelectorAll('.ag-home__section-heading').forEach((heading) => {
      addGroup(heading.children, 80);
    });

    [
      '.ag-home__product-grid',
      '.ag-home__benefit-grid',
      '.ag-home__review-grid',
      '.ag-home__collection-grid',
      '.ag-home__article-grid'
    ].forEach((selector) => {
      root.querySelectorAll(selector).forEach((grid) => addGroup(grid.children, 75));
    });

    root.querySelectorAll('.ag-home__story-inner').forEach((story) => {
      Array.from(story.children).forEach((element, index) => {
        addReveal(element, index * 100, element.classList.contains('ag-home__story-media'));
      });
    });

    addReveal(root.querySelector('.ag-home__reviews-intro'));
    addReveal(root.querySelector('.ag-home__benefit-footer'), 80);

    const showAll = () => revealItems.forEach((item) => item.classList.add('is-visible'));

    if (!('IntersectionObserver' in window)) {
      showAll();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -8% 0px'
    });

    requestAnimationFrame(() => revealItems.forEach((item) => observer.observe(item)));

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        const startY = window.scrollY;
        const targetY = Math.max(0, target.getBoundingClientRect().top + startY - 96);
        const distance = targetY - startY;
        const duration = 780;
        const startedAt = performance.now();

        const animateScroll = (now) => {
          const progress = Math.min((now - startedAt) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          window.scrollTo(0, startY + distance * eased);
          if (progress < 1) requestAnimationFrame(animateScroll);
        };

        requestAnimationFrame(animateScroll);
        history.replaceState(null, '', link.getAttribute('href'));
      });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-ag-home-motion]').forEach(initMotion);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
